export const EPG_SET_CURRENT_CHANNEL = 'EPG_SET_CURRENT_CHANNEL';

export const EPG_SET_CURRENT_EVENT = 'EPG_SET_CURRENT_EVENT';

export const EPG_CLEAR_CHANNEL_EVENT = 'EPG_CLEAR_CHANNEL_EVENT';

export const SET_MENU_OPTIONS = 'SET_MENU_OPTIONS';

export const SET_EVENT_FROM_EPG = 'SET_EVENT_FROM_EPG ';
